import React from 'react';
import Image from "next/image";
import { storeAssigned } from '@/services/Methods/normalMethods';
import { useRouter } from 'next/navigation';
import { WomenImage } from '@/assets/images';

const WellnessBusinessSection = () => {
    const router = useRouter();

    const handleStartBusiness = () => {
        router.push(`/${storeAssigned()}/distributor`);
    };

    const handleLearnOpportunity = () => {
        router.push(`/${storeAssigned()}/aboutus`);
    };

    const handleJoinCommunity = () => {
        router.push(`/${storeAssigned()}/lifestyle`);
    };

    return (
        <>
            <section className="wellness-business-section py-[50px] lg:py-[100px] bg-[#f5f7fc]">
                <div className="container mx-auto px-[15px]">
                    {/* Top Section - Two Columns */}
                    <div className="grid grid-cols-1 lg:grid-cols-2 xl:gap-16 gap-[30px]">
                        {/* Left Column */}
                        <div className="">
                            <h2 className="2xl:text-[55px] xl:text-[45px] text-[35px] leading-[1] font-semibold text-black mb-[30px]">
                                what if wellness could change your world?
                            </h2>

                            <div className="">
                                <p className="xl:text-[23px] text-[18px] text-black leading-[1.5] mb-[30px]">
                                    At b:hip, you can build a business around the products you love-earning while empowering others to live healthier, more flexible, and more fulfilled lives.
                                </p>

                                <p className="xl:text-[23px] text-[18px] text-black leading-[1.5] mb-[20px]">
                                    Whether you're seeking to earn extra income or connect with a wellness community, b:hip gives you the flexibility to define success - your way.
                                </p>
                            </div>

                            <div className="flex flex-col gap-4 items-left">
                                <button
                                    onClick={handleStartBusiness}
                                    className="bg-[#0388c7] xl:text-[24px] md:text-[20px] text-[18px] font-bold !no-underline text-white px-6 py-2 rounded-full font-semibold hover:bg-[#016a9b] transition-colors duration-300 w-fit text-left"
                                >
                                    start your business
                                </button>

                                <button
                                    onClick={handleLearnOpportunity}
                                    className="border-[3px] xl:text-[24px] md:text-[20px] text-[18px] font-bold !no-underline border-[#0388c7] text-[#0388c7] px-6 py-2 rounded-full font-semibold hover:bg-[#0388c7] hover:text-white transition-colors duration-300 w-fit text-left"
                                >
                                    learn about the opportunity
                                </button>
                            </div>
                        </div>

                        {/* Right Column */}
                        <div className="space-y-8 bg-[#fff] xl:p-10 p-[30px] xl:rounded-[40px] rounded-[20px]">
                            <h3 className="xl:text-[45px] md:text-[40px] text-[30px] font-semibold text-black lg:text-left text-center">
                                b:flexible means:
                            </h3>

                            <div className="grid grid-cols-1 sm:grid-cols-2 xl:gap-8 gap-2 mt-[50px] lg:text-start text-center">
                                {/* Feature 1 */}
                                <div className="space-y-2">
                                    <div className="xl:w-[70px] w-[60px] xl:h-[70px] h-[60px] bg-[#009cd2] rounded-[50px] flex items-center justify-center xl:p-[16px] p-[10px] lg:ml-0 mx-auto">
                                        {/* <svg className="w-[50px] h-[50px] text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                                        </svg> */}
                                        <img src="/images/display-icon.png" alt="" />
                                    </div>
                                    <p className="text-black font-normal xl:text-[20px] md:text-[18px] text-[16px] leading-[1.5]">
                                        Working when, where, and how you choose
                                    </p>
                                </div>

                                {/* Feature 2 */}
                                <div className="space-y-2">
                                    <div className="lg:ml-0 mx-auto xl:w-[70px] w-[60px] xl:h-[70px] h-[60px] bg-[#009cd2] rounded-[50px] flex items-center justify-center xl:p-[16px] p-[10px]">
                                        {/* <svg className="w-[50px] h-[50px] text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
                                        </svg> */}
                                        <img src="/images/card-2-icon.png" alt="" />
                                    </div>
                                    <p className="text-black font-normal xl:text-[20px] md:text-[18px] text-[16px] leading-[1.5]">
                                        Creating flexible income through authentic connection
                                    </p>
                                </div>

                                {/* Feature 3 */}
                                <div className="space-y-4">
                                    <div className="lg:ml-0 mx-auto xl:w-[70px] w-[60px] xl:h-[70px] h-[60px] bg-[#009cd2] rounded-[50px] flex items-center justify-center xl:p-[16px] p-[10px]">
                                        {/* <svg className="w-[50px] h-[50px] text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                                        </svg> */}
                                        <img src="/images/grouping-icon.png" alt="" />
                                    </div>
                                    <p className="text-black font-normal xl:text-[20px] md:text-[18px] text-[16px] leading-[1.5]">
                                        Growing a team through mentorship and shared success
                                    </p>
                                </div>

                                {/* Feature 4 */}
                                <div className="space-y-4">
                                    <div className="lg:ml-0 mx-auto xl:w-[70px] w-[60px] xl:h-[70px] h-[60px] bg-[#009cd2] rounded-[50px] flex items-center justify-center xl:p-[16px] p-[10px]">
                                        {/* <svg className="w-[50px] h-[50px] text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                        </svg> */}
                                        <img src="/images/sereen-2-icon.png" alt="" />
                                    </div>
                                    <p className="text-black font-normal xl:text-[20px] md:text-[18px] text-[16px] leading-[1.5]">
                                        Accessing world-class tools, training, and community
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Bottom Section - Image and Text */}

                </div>
            </section>


            <section className='bg-white xl:p-[130px_0_180px] lg:p-[100px_0_100px] p-[50px_0_50px]'>
                <div className="container mx-auto px-[15px] bg-white">
                    <div className="grid grid-cols-1 lg:grid-cols-2 xl:gap-16 gap-[25px] items-center">
                        {/* Left Side - Image */}
                        <div className="order-2 lg:order-1">
                            <div className="relative rounded-2xl overflow-hidden">
                                <div className="w-full h-96 lg:h-[500px] flex">

                                    <div className="text-center text-gray-600 w-full ">
                                        <Image src={WomenImage} alt="Women Image" className="w-full h-full object-cover rounded-[10px] w-full" />

                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Right Side - Text Content */}
                        <div className="order-1 lg:order-2">
                            <h3 className="text-[30px] xl:text-[50px] md:text-[40px] text-[30px] font-bold text-black font-semibold    ">
                                we rise by lifting others
                            </h3>

                            <p className="xl:text-[20px] md:text-[18px] text-[16px] text-black leading-[1.5] mb-[20px] mt-[15px]">
                                From personal mentorship and leadership training to recognition and rewards, bhip provides the tools you need to grow a business and a better you.
                            </p>

                            <div className="space-y-6">
                                <h4 className="text-[28px] leading-normal font-semibold text-black">
                                    Empowerment through:
                                </h4>

                                <ul className="space-y-4">
                                    <li className="flex items-center gap-[10px]">
                                        <div className="">
                                            {/* <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                                            </svg> */}
                                            <img className='w-[30px]' src="/images/check-arrow.png" alt="" />
                                        </div>
                                        <span className="text-[#000] md:text-[20px] text-[16px] text-black leading-[1.3]">Coaching and global training systems</span>
                                    </li>

                                    <li className="flex items-center gap-[10px]">
                                        <div className="">
                                            <img className='w-[30px]' src="/images/check-arrow.png" alt="" />
                                        </div>
                                        <span className="text-[#000] md:text-[20px] text-[16px] text-black leading-[1.3]">Community events and wellness summits</span>
                                    </li>

                                    <li className="flex items-center gap-[10px]">
                                        <div className="">
                                            <img className='w-[30px]' src="/images/check-arrow.png" alt="" />
                                        </div>
                                        <span className="text-[#000] md:text-[20px] text-[16px] text-black leading-[1.3]">Recognition and celebration of every milestone</span>
                                    </li>

                                    <li className="flex items-center gap-[10px]">
                                        <div className="">
                                            <img className='w-[30px]' src="/images/check-arrow.png" alt="" />
                                        </div>
                                        <span className="text-[#000] md:text-[20px] text-[16px] text-black leading-[1.3]">Digital back-office tools to help you scale your business</span>
                                    </li>
                                </ul>
                            </div>

                            <button
                                onClick={handleJoinCommunity}
                                className="bg-[#009cd2] xl:text-[24px] md:text-[20px] text-[18px] font-bold !no-underline text-white px-8 py-3 rounded-full font-semibold hover:bg-[#0088b8] transition-colors duration-300 w-fit text-left mt-[20px]"
                            >
                                join the community
                            </button>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default WellnessBusinessSection;
